import { Box, Button, Icon, IconButton, MenuItem, TextField, Tooltip } from "@mui/material";
import { Controller, useFieldArray } from "react-hook-form";
import InputMascarado from "../../../shared/components/formulario/input-mascarado/InputMascarado";
import { mascaraMoedaReal } from "../../../shared/utils/mascaras/mascaraMoedaReal";
import { BankAccountType } from "../../../shared/utils/enum/enum";

interface AgenciaContasFormPartProps {
  control: any;
  idx: number;
  errors: any;
  methods: any;
}

export function AgenciaContasFormPart({
  control,
  idx,
  errors,
  methods,
}: AgenciaContasFormPartProps) {
  const {
    fields: contas,
    append: appendConta,
    remove: removeConta,
  } = useFieldArray({
    control,
    name: `agencies.${idx}.accounts`,
  });

  return (
    <Box mt={2}>
      <Button
        variant="outlined"
        onClick={() =>
          appendConta({
            accountNumber: "",
            digit: "",
            name: "",
            initialBalance: 0,
            active: "true",
            type: "",
          })
        }
      >
        Adicionar Conta
      </Button>
      {contas.map((conta, cIdx) => (
        <Box
          key={conta.id || cIdx}
          display="grid"
          gridTemplateColumns="1fr 1fr 1fr 1fr 1fr 1fr"
          gap={2}
          mt={2}
        >
          <Controller
            name={`agencies.${idx}.accounts.${cIdx}.accountNumber`}
            control={control}
            render={({ field }) => (
              <TextField
                label="Número da Conta"
                {...field}
                error={
                  !!errors.agencies?.[idx]?.accounts?.[cIdx]?.accountNumber
                }
                helperText={
                  errors.agencies?.[idx]?.accounts?.[cIdx]?.accountNumber
                    ?.message
                }
                fullWidth
              />
            )}
          />
          <Controller
            name={`agencies.${idx}.accounts.${cIdx}.digit`}
            control={control}
            render={({ field }) => (
              <TextField
                label="Dígito"
                {...field}
                error={!!errors.agencies?.[idx]?.accounts?.[cIdx]?.digit}
                helperText={
                  errors.agencies?.[idx]?.accounts?.[cIdx]?.digit?.message
                }
                fullWidth
              />
            )}
          />
          <Controller
            name={`agencies.${idx}.accounts.${cIdx}.name`}
            control={control}
            render={({ field }) => (
              <TextField
                label="Nome da Conta"
                {...field}
                error={!!errors.agencies?.[idx]?.accounts?.[cIdx]?.name}
                helperText={
                  errors.agencies?.[idx]?.accounts?.[cIdx]?.name?.message
                }
                fullWidth
              />
            )}
          />
          <InputMascarado
            name={`agencies.${idx}.accounts.${cIdx}.initialBalance`}
            methods={methods}
            label="Saldo Inicial"
            mask={mascaraMoedaReal}
          />

          <Controller
            name={`agencies.${idx}.accounts.${cIdx}.type`}
            control={control}
            render={({ field }) => (
              <TextField
                label="Tipo de Conta"
                select
                {...field}
                error={!!errors.agencies?.[idx]?.accounts?.[cIdx]?.type}
                helperText={
                  errors.agencies?.[idx]?.accounts?.[cIdx]?.type?.message
                }
                fullWidth
              >
                <MenuItem value={BankAccountType.CHECKING_ACCOUNT}>
                  Conta Corrente
                </MenuItem>
                <MenuItem value={BankAccountType.SAVINGS_ACCOUNT}>
                  Conta Poupança
                </MenuItem>
              </TextField>
            )}
          />
          <Controller
            name={`agencies.${idx}.accounts.${cIdx}.active`}
            control={control}
            render={({ field }) => (
              <TextField
                label="Situação"
                select
                {...field}
                SelectProps={{ native: true }}
                error={!!errors.agencies?.[idx]?.accounts?.[cIdx]?.active}
                helperText={
                  errors.agencies?.[idx]?.accounts?.[cIdx]?.active?.message
                }
                fullWidth
              >
                <option value="true">Ativa</option>
                <option value="false">Inativa</option>
              </TextField>
            )}
          />

          <Tooltip title="Remover Conta">
            <IconButton
              size="small"
              color="error"
              sx={{
                alignSelf: "center",
                width: "40px",
                height: "40px",
                borderRadius: "50%",
              }}
              onClick={(e) => {
                e.stopPropagation();
                removeConta(idx);
              }}
            >
              <Icon>delete</Icon>
            </IconButton>
          </Tooltip>
        </Box>
      ))}
    </Box>
  );
}
